angular.module('am4').controller('googleCalendarIdCtrl', function($scope, $rootScope, $stateParams, calendarService, ngDialog, errorService) {
    const that = this;
    that.facility_id = $stateParams.id;

    that.unlinkExternalCalendarId = function(calendarId) {
        const data = {
            id : calendarId
        };
        calendarService.removeExternalCalendarId(that.facility_id, data)
        .then(function(response) {
            if (response.status === 204) {
                $rootScope.$broadcast('updateCalendar');
                ngDialog.close();
            }
        })
        .catch(function(e) {
            ngDialog.close();
            errorService.addError('PUBLIC_CALENDAR_DELETE_ERROR', e);
        });
    };

    that.addExternalCalendarId = function(calendarId) {
        const data = {
            id : calendarId
        };
        calendarService.addExternalCalendarId(that.facility_id, data)
        .then(function(response) {
            if (response.status === 200) {
                $rootScope.$broadcast('updateCalendar');
                ngDialog.close();
            }
        })
        .catch(function(e) {
            ngDialog.close();
            if (e.status === 400) {
                errorService.addError('PUBLIC_CALENDAR_ACCESS_ERROR');
            } else {
                errorService.addError('PUBLIC_CALENDAR_UPDATE_ERROR', e);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/googleCalendarIdCtrl.js